import { render, staticRenderFns } from "./year-person-report.vue?vue&type=template&id=23b3fb54&scoped=true"
import script from "./year-person-report.vue?vue&type=script&lang=js"
export * from "./year-person-report.vue?vue&type=script&lang=js"
import style0 from "./year-person-report.vue?vue&type=style&index=0&id=23b3fb54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b3fb54",
  null
  
)

export default component.exports